import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function MatchIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 60 55.16">
      <path d="M29.46 37v-1.47l-.35-.08a5.43 5.43 0 01-3.71-3 .88.88 0 010-.71 1 1 0 01.56-.53 1.1 1.1 0 01.41-.08 1 1 0 011 .59 3.43 3.43 0 003.19 2c1.67 0 3.45-.91 3.45-2.9 0-1.43-1.2-2.39-3.68-2.92h-.23c-4.43-1-5.1-3.4-5.1-4.77a4.83 4.83 0 014.1-4.65l.38-.07V17a1 1 0 012.06 0v1.51l.35.08a5.46 5.46 0 013.26 2.2.91.91 0 01.16.73 1 1 0 01-.44.6 1.08 1.08 0 01-.8.13 1 1 0 01-.65-.44 3.48 3.48 0 00-2.92-1.52c-1.66 0-3.44.91-3.44 2.9 0 1.44 1.21 2.4 3.68 2.92 4.58 1 5.26 3.42 5.26 4.77a4.83 4.83 0 01-4.1 4.65l-.38.07V37a1 1 0 01-2.06 0z"/>
      <path d="M30 55.16l-.5-.29a97 97 0 01-14.67-11C5 34.91 0 26.15 0 17.86A17.91 17.91 0 0117.92 0 18 18 0 0130 4.67a17.93 17.93 0 0130 13.19c0 8.29-5 17-14.83 26a97 97 0 01-14.67 11zM18 2A15.91 15.91 0 002 17.86C2 35 26.18 50.49 30 52.83c3.82-2.34 28-17.87 28-35A15.91 15.91 0 0042.09 2a16 16 0 00-11.38 4.76l-.71.73-.71-.73A16 16 0 0018 2z"/>
    </SvgIcon>
  )
}
export default MatchIcon
